<script>
import {
  SubscriptionFailurePageElementMixin,
} from "%/dynamic-component-editor/standard-pages/subscription-failure-page/subscription-failure-page-element-mixin";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import ButtonOptions from "%/dynamic-component-editor/bundles/button-options";
import TextOptions from "%/dynamic-component-editor/bundles/text-options";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import { mapState } from "pinia";

export default {
  name: "BackButton",
  elementPanelSettings: {
    displayName: "Back Button",
    displayIcon: "arrow-left",
    elementGroup: "subscriptionFailureElements",
    elementType: "element",
  },
  extends: BaseButtonElement,
  mixins: [SubscriptionFailurePageElementMixin],
  inject: ["redirectUri"],
  optionBundles: [
    new ButtonOptions({}, {
      "button-action": true,
      "link-type": true,
      "href-option": true,
    }),
    new TextOptions({
      "default.text-wrap": "wrap",
    }),
  ],
  computed: {
    ...mapState(useGeneralStore, ["links"]),
  },
  methods: {
    handleButtonClick() {
      let uri = this.redirectUri;
      if (uri) {
        uri = uri.replace(/\\\//g, "/");
      }
      window.location = uri || `${this.links.web}/subscriptions/failure`;
    },
  },
};
</script>
